// One way to write a date and a time, for both apps (docs/32 A3):
//   formatDateTime → "15 Oct 2026, 6:00 pm"   formatDate → "15 Oct 2026"   formatTime → "6:00 pm"
// An empty or unreadable value gives "—". `timeZone` (an IANA name) writes the
// moment as it reads there, and `{ zoneLabel: true }` adds the zone ("… IST").
// Byte-identical in apps/candidate/src/ui (designLayer.test.js).

const LOCALE = "en-IN";

function toDate(value) {
  if (value === null || value === undefined || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function parts(d, options) {
  const out = {};
  for (const p of new Intl.DateTimeFormat(LOCALE, options).formatToParts(d)) out[p.type] = p.value;
  return out;
}

function zoneName(d, timeZone) {
  try {
    const p = parts(d, { timeZone, timeZoneName: "short" });
    // en-IN writes Asia/Kolkata as "IST"; a zone without a short name gives "GMT+5:30" — kept.
    return p.timeZoneName || "";
  } catch {
    return "";
  }
}

// Our own month words: ICU writes September "Sept" in one runtime and "Sep" in another.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatDate(value, { timeZone } = {}) {
  const d = toDate(value);
  if (!d) return "—";
  const p = parts(d, { day: "numeric", month: "numeric", year: "numeric", ...(timeZone ? { timeZone } : {}) });
  return `${p.day} ${MONTHS[Number(p.month) - 1]} ${p.year}`;
}

export function formatTime(value, { timeZone, zoneLabel } = {}) {
  const d = toDate(value);
  if (!d) return "—";
  const p = parts(d, { hour: "numeric", minute: "2-digit", hour12: true, ...(timeZone ? { timeZone } : {}) });
  const t = `${p.hour}:${p.minute} ${String(p.dayPeriod || "").toLowerCase()}`.trim();
  return zoneLabel ? `${t} ${zoneName(d, timeZone)}`.trim() : t;
}

export function formatDateTime(value, options = {}) {
  const d = toDate(value);
  if (!d) return "—";
  return `${formatDate(d, options)}, ${formatTime(d, options)}`;
}
